import { Accordion } from '../../../../../components/general/accordion';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrNotificationClientProps } from './props';
import { usePqrNotificationClient } from './hook';

export const PqrNotificationClient = ({
    notificationClient,
}: PqrNotificationClientProps) => {
    const { formik } = usePqrNotificationClient(notificationClient);

    return (
        <Accordion
            title="NOTIFICACIÓN CLIENTE"
            icon={<NotificationsIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="E-mail notificación"
                        name="email"
                        size="small"
                        value={formik.values.email}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Teléfono notificación"
                        name="phone"
                        size="small"
                        value={formik.values.phone}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
